module.exports = __webpack_public_path__ + "src/assets/models/petri/alcohol_alco.fbx";